
export const FindOpenPosition = (_x, _y, _step, _group, _entry, _size = {width: 100, height: 180}) => {

  let x = _x;
  let y = _y;

  let mergeEntity = [..._step.map(s => ({ position: s.position, width: 100, height: 180 })), ..._group.map(g => ({ position: g.position, width: 320, height: 200 })), ..._entry.map(e => ({ position: e.position, width: 100, height: 180 }))];

  let foundInterference = true;

  while (y < 9800 && foundInterference)
  {
    foundInterference = false;

    for (const e of mergeEntity)
    {


      //Test
      //console.log(`Y: ${e.position.y} >  ${y - e.height} && ${e.position.y} < ${y + e.height}`);
      
      
      if ((x > e.position.x - e.width && x < e.position.x + e.width ) && (e.position.y >= y - e.height && e.position.y <= y + e.height))
      {
        //console.log("interference", e);
        foundInterference = true;
        break;
      }
    }



    if (foundInterference)
      y += 20;
  }

  if (y >= 9800) x = _y;

  return {x, y};
}